import httpErrorMessage from "common/utils/httpErrorMessage";
import { getPostLoginRedirect } from "lib/auth";
import { useUserContext } from "lib/state/UserContextProvider";
import Button from "ui/buttons/Button";
import useAppContext from "ui/hooks/useAppContext";
import IconStop from "ui/icons/IconStop";
import styles from "./AppError.module.scss";

interface AppErrorProps {
  statusCode: number;
  redirectTo?: string;
  errorMessage?: string;
}

export default function AppError({ statusCode, redirectTo, errorMessage }: AppErrorProps) {
  const { setUserNotification } = useAppContext();
  const { name, message } = httpErrorMessage(statusCode);
  const { user } = useUserContext();

  const redirectUser = async (): Promise<void> => {
    const [url, notification] = await getPostLoginRedirect(user, redirectTo);

    if (notification) {
      setUserNotification(notification);
      return;
    }

    window.location.href = url;
  };

  return (
    <div className={styles.wrapper} data-testid="app-error" data-error-code={statusCode}>
      <h2>
        <IconStop size={22} color="orangeDark" />
        <span>{name}</span>
      </h2>
      <p>{errorMessage || message}</p>
      <Button btnSize="large" onClick={redirectUser}>
        <span>Go {redirectTo ? "back" : "home"}</span>
      </Button>
    </div>
  );
}
